export const mapFormConfigs = (formConfigs: any) => {
    const newFormConfigsMap = {};
    formConfigs.forEach((form: any) => {
        const {
            should_capture_details,
            details_update_required,
            captured_data,
            ui_config,
            form_type,
        } = form;
        newFormConfigsMap[form_type] = {
            uiConfig: ui_config,
            should_capture_details,
            details_update_required,
            captured_data,
        };
    });
    return newFormConfigsMap;
};
